// src/routes/index.jsx
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import CategoryPage from '../pages/_catagory/categoryPage';
import ProductPage from '../pages/_product/productPage';
import TrendingProductPage from '../pages/_product/TrendingProductLayout';
import CartPage from '../pages/_cart/cartPage';
import Home from '../pages/home';
import PurchaseLayout from '../layouts/purchaseLayout';
import PurchasePage from '../pages/_purchase/purchasePage';
import VnPayReturnPage from '../pages/_purchase/vnpay_return/page';
import ShopProfile from '../pages/_profile/_shop/shopProfile';
import SearchResultPage from '../pages/_product/_search/page';

export const mainRoutes = (
  <>
    {/* Main layout */}
    <Route element={<MainLayout />}>
      <Route path="/" element={<Home />} />
    </Route>
    {/* Danh mục sản phẩm */}
    <Route element={<MainLayout />}>
      <Route path="/category/:categoryName" element={<CategoryPage />} />
    </Route>
    {/* Sản phẩm */}
    <Route element={<MainLayout />}>
      <Route
        path="/product/TrendingProduct"
        element={<TrendingProductPage />}
      />
      <Route path="/product/:productName" element={<ProductPage />} />
      <Route path="/search" element={<SearchResultPage />} />
    </Route>
    {/* Giỏ hàng */}
    <Route element={<MainLayout />}>
      <Route path="/cart" element={<CartPage />} />
    </Route>
    {/* Trang cá nhân */}
    <Route element={<MainLayout />}>
      <Route path="/profile/shop/:shopId" element={<ShopProfile />} />
    </Route>

    {/* Mua hàng */}
    <Route element={<PurchaseLayout />}>
      <Route path="/purchase" element={<PurchasePage />} />
      <Route path="/purchase/vnpay_return" element={<VnPayReturnPage />} />
    </Route>
  </>
);
